import {
  ActivityFieldsFragment,
  TaskStatus,
  UpdateTaskMutationVariables,
  useUpdateTaskMutation,
} from '~/graphql/types';
import useAddToast from '~/hooks/useAddToast';
import useTrackEvent from '~/hooks/useTrackEvent';
import formatToastMessage from '~/util/formatToastMessage';
import Catalog from '~/Catalog';

const text = {
  deleteSuccess: 'Taak is succesvol verwijderd.',
  completeSuccess: 'Taak is succesvol voltooid.',
  reopenSuccess: 'Taak is succesvol heropend.',
};

type Props = {
  onAfterUpdate?: (updatedActivity: ActivityFieldsFragment) => void;
};

const useTaskUpdateHandler = ({ onAfterUpdate }: Props = {}) => {
  const [updateTask] = useUpdateTaskMutation();
  const addToast = useAddToast();
  const trackEvent = useTrackEvent();

  const handleUpdateTask = async (variables: UpdateTaskMutationVariables) => {
    const { data, errors } = await updateTask({ variables });

    if (data?.updateTask) {
      onAfterUpdate?.(data.updateTask);

      if (variables.update.deleted) {
        addToast([formatToastMessage(text.deleteSuccess, 'success')]);
        trackEvent({
          eventName: 'task_deleted',
          parameters: { task_id: variables.id },
        });
      } else if (variables.update.status === TaskStatus.Closed) {
        addToast([formatToastMessage(text.completeSuccess, 'success')]);
        trackEvent({
          eventName: 'task_completed',
          parameters: { task_id: variables.id },
        });
      } else if (variables.update.status === TaskStatus.Open) {
        addToast([formatToastMessage(text.reopenSuccess, 'success')]);
        trackEvent({
          eventName: 'task_reopened',
          parameters: { task_id: variables.id },
        });
      }
    }

    if (errors && errors.length > 0) {
      addToast([
        formatToastMessage(Catalog.genericUnknownErrorMessageShort, 'danger'),
      ]);
    }
  };

  return handleUpdateTask;
};

export default useTaskUpdateHandler;
